import { US_DATA_CENTER_ENDPOINT, dataCenterRegions } from 'client/util/Constants/SignupConstants';

/**
 * Production console hostnames from SignupConstants data center configuration.
 * Only includes *.jumpcloud.com endpoints; WoK jcplatform.dev overrides are excluded.
 *
 * @returns {Set<String>}
 */
export function getProductionSignupHosts() {
  return new Set(
    [US_DATA_CENTER_ENDPOINT, ...Object.values(dataCenterRegions).map((region) => region?.endpoint)]
      .filter((host) => host?.endsWith('.jumpcloud.com')),
  );
}

/**
 * @param {String} [hostname] - Host to check (defaults to window.location.hostname)
 * @returns {Boolean}
 */
export function isProductionSignupHost(
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
) {
  return Boolean(hostname) && getProductionSignupHosts().has(hostname);
}
